import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CadastrarInsumoRecord from '@components/InsumoRecord/CadastrarInsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';
import { withRouter } from 'react-router-dom';

/**
 * Tela para cadastro de bactericidas
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function EditarBactericidas(props) {
  useEffect(() => {
    const title = 'bactericidas.cadastroDeBactericidas';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <CadastrarInsumoRecord
      id={props.match.params.id}
      insumoURL={'bactericidas'}
      insumoEnum={Insumo.BACTERICIDA}
      infoUsuario={props.infoUsuario}
      saveMessage={formatMessage(
        'bactericidas.' +
          (props.match.params.id
            ? 'falhaAoEditarBactericidas'
            : 'bactericidasCadastradoComSucesso')
      )}
      falhaSaveMesssage={formatMessage(
        'bactericidas.' +
          (props.match.params.id
            ? 'falhaAoEditarBactericidas'
            : 'falhaAoCadastrarBactericidas')
      )}
      falhaCarregarMensagem={formatMessage('bactericidas.falhaAoCarregarBactericidas')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

export default withRouter(connect(mapStateToProps)(EditarBactericidas));
